import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Footer.css";
import footerlogo from '../assets/images/footer-logo.png';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleRemedyClick = (e) => {
    e.preventDefault();
    
    // If we're already on the home page, just scroll to the section
    if (location.pathname === '/') {
      const remedySection = document.getElementById('remedy-section');
      if (remedySection) {
        remedySection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // Navigate to home page first, then scroll to section
      navigate('/');
      // Small delay to ensure the page has loaded before scrolling
      setTimeout(() => {
        const remedySection = document.getElementById('remedy-section');
        if (remedySection) {
          remedySection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };
const handleReportClick = (e) => {
    e.preventDefault();
    
    // If we're already on the home page, just scroll to the section
    if (location.pathname === '/') {
      const reportSection = document.getElementById('report-section');
      if (reportSection) {
        reportSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // Navigate to home page first, then scroll to section
      navigate('/');
      // Small delay to ensure the page has loaded before scrolling
      setTimeout(() => {
        const reportSection = document.getElementById('report-section');
        if (reportSection) {
          reportSection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };
  return (
    <footer className="astro-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Logo + About */}
          <div className="footer-col">
            <img
              src={footerlogo}
              alt="AstroShubh Logo"
              className="footer-logo"
            />
            <p>
              Your trusted online astrology portal providing accurate Vedic
              astrology predictions and consultations.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61577298920599" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
          
              <a href="https://www.instagram.com/astroshubhofficial/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram" ></i>
              </a>
              <a href="https://youtube.com/@astroshubhofficial?si=NSWfL1H9Q63QRaL8" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/aboutus">About Us</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h3>Services</h3>
            <ul>
              <li>
                <a href="#report-section">Prashna Kundli</a>
              </li>
              <li>
                <a href="#" onClick={handleRemedyClick}>Universal Remedy</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h3>Contact Us</h3>
            <ul className="contact-info">
              <li><i className="fas fa-envelope"></i> support@astroshubh.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; 2025 AstroShubh. All Rights Reserved.</p>
          <div className="footer-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-and-condition">Terms & Conditions</a>
            <a href="/refund-policy">Refund Policy</a>
              <a href="/shipping-delivery-policy">Shipping & Delivery Policy</a>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
